import React, { useState } from 'react';
import type { MessageButton, CommandVariable } from '../../../../types/chat-message';
import { DateRangePickerModal } from '../Conversation/DateRangePickerModal';

const checkIsHidden = (commandVariables?: CommandVariable[]): boolean => {
  if (!commandVariables) return false;
  return commandVariables.find(v => v?.name === 'hidden_message')?.value === 'true';
};

interface ReportActionButtonsProps {
  buttons?: MessageButton[];
  isDisabled: boolean;
  onButtonClick?: (name: string, id: any, isHidden?: boolean) => void;
  reportType?: string;
  suggestionTitle?: string;
}

const SuggestionHeader: React.FC<{ title?: string }> = ({ title }) => {
  if (!title) return null;
  return (
    <>
      <div className="rr-suggestion-divider">
        <span>Gợi ý</span>
      </div>
      <div className="rr-suggestion-title">{title}</div>
    </>
  );
};

interface ButtonsListProps {
  buttons: MessageButton[];
  onItemClick: (btn: MessageButton) => void;
}

const ButtonsList: React.FC<ButtonsListProps> = ({ buttons, onItemClick }) => (
  <div className="rr-buttons">
    {buttons.map((btn, i) => (
      <button
        key={btn?.id ?? i}
        className="rr-btn"
        onClick={() => onItemClick(btn)}
        type="button"
      >
        {btn?.name}
      </button>
    ))}
  </div>
);

export const ReportActionButtons: React.FC<ReportActionButtonsProps> = ({
  buttons,
  isDisabled,
  onButtonClick,
  reportType,
  suggestionTitle,
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedButtonId, setSelectedButtonId] = useState<number | null>(null);

  if (isDisabled || !buttons || buttons.length === 0) return null;

  const handleButtonClick = (btn: MessageButton) => {
    if (btn?.name === 'Chọn thời gian') {
      setSelectedButtonId(btn.id);
      setShowDatePicker(true);
    } else if (btn?.name) {
      onButtonClick?.(btn.name, btn.id, checkIsHidden(btn.commandVariables));
    }
  };

  const handleDateRangeConfirm = (dateRange: string) => {
    if (selectedButtonId !== null) {
      onButtonClick?.(dateRange, null, false);
      setShowDatePicker(false);
      setSelectedButtonId(null);
    }
  };

  return (
    <>
      <div className="rr-buttons-container">
        <SuggestionHeader title={suggestionTitle} />
        <ButtonsList buttons={buttons} onItemClick={handleButtonClick} />
      </div>
      <DateRangePickerModal
        open={showDatePicker}
        onClose={() => setShowDatePicker(false)}
        onConfirm={handleDateRangeConfirm}
        reportType={reportType}
      />
    </>
  );
};
